// Party-existence probe — supabase provider.
//
// Behavioral twin of src/lib/partyValidator.js. "Expired" is best-effort
// without a dedicated room registry: query for a single message in the room.
// Zero rows => the party never existed or has aged out, both surfaced the same
// way (drop the user back to GLOB with the one-shot expired banner).
import { getClient } from './client.js';

export const DEFAULT_PARTY = 'GLOB';

/**
 * Returns `true` when the party is reachable (or is DEFAULT_PARTY, always
 * implicit), `false` when it appears expired / unknown. A null/empty `code`
 * resolves to `true`. NETWORK / SDK ERRORS RESOLVE TO `true` — a transient
 * outage must never unilaterally evict the user from their party.
 *
 * @param {string | null | undefined} code
 * @returns {Promise<boolean>}
 */
export async function validatePartyExists(code) {
  if (!code) return true;
  if (code === DEFAULT_PARTY) return true;
  try {
    const { data, error } = await getClient()
      .from('messages')
      .select('id')
      .eq('code', code)
      .limit(1);
    // Network/SDK error → be conservative and keep the user where they were.
    if (error) return true;
    return (data?.length ?? 0) > 0;
  } catch {
    return true;
  }
}

export default validatePartyExists;
